export default __webpack_public_path__ + "static/universitycenter-c5002e42b31d27f728c0ab63d9513768.png";